// extracted by mini-css-extract-plugin
export default {"bloco":"IdadeDesconhecida_bloco__3TetL","containerBloco":"IdadeDesconhecida_containerBloco__3xxmC","correct":"IdadeDesconhecida_correct__++q9n"};